import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91b0a53a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-visualiser" }
const _hoisted_2 = { class: "layer layer-1" }
const _hoisted_3 = { class: "layer layer-2" }
const _hoisted_4 = { class: "foreground" }
const _hoisted_5 = { class: "button-inner" }

import {computed} from 'vue'

  import LazyImage from '@/components/LazyImage'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BigButton',
  props: {
    audioActive: { type: Boolean }
  },
  emits: ['pressed'],
  setup(__props: any, { emit }) {

const props = __props as {
    audioActive: boolean
  };

  

  

  function onButtonClick() {
    emit('pressed')
  }

  const classObject = computed(() => {
    return {
      'is-active': props.audioActive
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["big-button", _unref(classObject)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(LazyImage), {
          class: "image",
          src: require('@/assets/images/AV_1.png'),
          alt: "Audio visualiser effect"
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(LazyImage), {
          class: "image",
          src: require('@/assets/images/AV_2.png'),
          alt: "Audio visualiser effect"
        }, null, 8, ["src"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "button",
        onClick: onButtonClick
      }, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ], 2))
}
}

})